export enum ReportTypeModalModes {
  CREATE = "create",
  EDIT = "edit",
  VIEW = "view",
}
